import { render, staticRenderFns } from "./shipping-type-edit.vue?vue&type=template&id=498696d1&"
import script from "./shipping-type-edit.vue?vue&type=script&lang=js&"
export * from "./shipping-type-edit.vue?vue&type=script&lang=js&"
import style0 from "./shipping-type-edit.vue?vue&type=style&index=0&id=498696d1&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports